import { NgModule } from '@angular/core';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { SccRegisterComponent } from './scc-register.component';

const routes: Routes = [
  { path: '', component: SccRegisterComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SccRegisterRoutingModule { }
